import { Link } from "react-router-dom"

const FullLogo = () => {
  return (
    <Link to="/" className="text-2xl font-bold text-primary">
      MatDash
    </Link>
  )
}

export default FullLogo 